<template>
  <v-sheet :class="sheetClasses">
    <v-row class="sheet__row">
      <v-icon
        :class="iconClasses"
        dark
      >{{icon}}</v-icon>

      <div :class="contentClasses">
        <div class="text__block">
          <slot style="" name="content"/>
        </div>
      </div>
    </v-row>
  </v-sheet>
</template>

<script>

const ICONS = {
  'info'  : 'mdi-information-outline',
  'warning'  : 'mdi-alert-outline',
  'alert': 'mdi-alert-circle-outline'
}

export default {
  props: {
    type: {
      type: String,
      default: 'info'
    },
    float: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    icon() {
      return ICONS[this.type]
    },
    sheetClasses() {
      return {
        'sheet' : true,
        [`sheet--${this.type}`] : true,
        'sheet--float' : this.float,
      }
    },
    iconClasses() {
      return {
        'sheet__icon' : true,
        [`sheet__icon--${this.type}`] : true,
        'sheet__icon--float' : this.float,
      }
    },
    contentClasses() {
      return {
        'sheet__content' : true,
        [`sheet__content--${this.type}`] : true,
        'sheet__content--float' : this.float,
        'pa-0' : this.float,
        'ml-2' : true,
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.sheet
  min-height 80px
  border-radius 5px
  &--info
    border 3px solid #e0f1ff !important
    background-color rgba(135, 206, 250, 0.1)
  &--warning
    border 3px solid #fe9e9e !important
    background-color: #fea015 !important;
    border-left: solid 5px #c07c18 !important;
    border-top 3px solid #ed9b22 !important
    border-right 3px solid #ed9b22 !important
    border-bottom 3px solid #ed9b22 !important
  &--alert
    border 3px solid #fe9e9e !important
    background-color rgb(233 83 94 / 1) !important
    border-left solid 5px #ab101b !important
    border-top 3px solid #e9535e !important
    border-right 3px solid #e9535e !important
    border-bottom 3px solid #e9535e !important
  &--float
    border-radius 0px
    box-shadow -3px 3px 13px 1px grey

  &__row
    min-height 80px

  &__area
    position relative

  &__icon
    font-size 35px
    margin-left 10px
    position absolute
    top 50%
    left 35px
    transform translateY(-50%) translateX(-50%)
    -webkit- transform translateY(-50%) translateX(-50%)
    &--info
      color #8bcbff
    &--warning
      color #ff6565
    &--alert
      color #ff6565
    &--float
      color white

  &__content
    font-size 13px
    &--info
      color #515d63
    &--warning
      color #515d63
    &--alert
      color #515d63
    &--float
      color #fff
      font-size 15px
      width 100%
      margin-left 80px !important

.text__block
  height 100%
  display: flex;
  align-items: center;
  padding 10px 0px

</style>
